import { ROLES } from '@wareclouds/frontend-common/b2c';

import { leadInstance } from '@/libs/leadInstances';

export async function createLead({ email }) {
  return leadInstance.post('/leads', {
    email,
    id_role: ROLES.CLOUDER,
  });
}

export async function getLeadEvents() {
  return leadInstance.get('/leads/events');
}

export async function postLeadEvent(payload) {
  return leadInstance.post('/leads/events', payload);
}

export async function requestExternalValidation() {
  return leadInstance.post('/leads/external-validation');
}
